"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Price_1 = __importDefault(require("../Price"));
var react_i18next_1 = require("react-i18next");
var lodash_1 = require("lodash");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var DailyMonthlyPrice = function (_a) {
    var _b, _c, _d, _e;
    var monthlyPrice = _a.monthlyPrice, dailyPriceFull = _a.dailyPriceFull, isDeveloper = _a.isDeveloper;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.price_container },
        ((_b = monthlyPrice[0]) === null || _b === void 0 ? void 0 : _b.price) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.monthly_price },
            react_1.default.createElement(Price_1.default, { value: monthlyPrice, isDeveloper: isDeveloper, className: "price", defaultValue: t('POST_CARD.CONTRACTUAL') }),
            react_1.default.createElement("p", { className: styles_module_scss_1.default.month }, t('MY_ANNOUNCEMENTS.MONTH')))),
        ((_c = monthlyPrice[0]) === null || _c === void 0 ? void 0 : _c.price) &&
            !lodash_1.isUndefined(dailyPriceFull) &&
            ((_d = dailyPriceFull[0]) === null || _d === void 0 ? void 0 : _d.price) && react_1.default.createElement("span", { className: "slash" }, "/"),
        !lodash_1.isUndefined(dailyPriceFull) && ((_e = dailyPriceFull[0]) === null || _e === void 0 ? void 0 : _e.price) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.daily_price },
            react_1.default.createElement(Price_1.default, { value: dailyPriceFull, className: "price", defaultValue: t('POST_CARD.CONTRACTUAL') }),
            react_1.default.createElement("p", { className: styles_module_scss_1.default.daily }, t('MY_ANNOUNCEMENTS.DAILY'))))));
};
exports.default = DailyMonthlyPrice;
